'use client'
import { useEffect, useLayoutEffect, useRef, useState } from 'react'
import FaqSection from './_components/FaqSection'
import DetailsSection from './_components/DetailsSection'

const page = () => {
  const [activeTab, setActiveTab] = useState('signUp')
  const activeTabRef = useRef(activeTab)
  const isScrollingRef = useRef(false)
  const debounceTimeout = useRef(null)
  useLayoutEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    })
  }, [])

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (isScrollingRef.current) return // Ignore updates during manual scroll

      // Debounce logic to avoid rapid updates
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current)
      }

      debounceTimeout.current = setTimeout(() => {
        const allElements = document.querySelectorAll('.main')
        allElements.forEach((element) => {
          const currentElement = element.getBoundingClientRect()
          if (currentElement.y <= 160) {
            const newActiveTab = element.getAttribute('id')
            if (activeTabRef.current !== newActiveTab) {
              activeTabRef.current = newActiveTab
              setActiveTab(newActiveTab)
            }
          }
        })
      }, 100) // Debounce interval (adjust as needed)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (debounceTimeout.current) clearTimeout(debounceTimeout.current)
    }
  }, [])

  const moveTo = (to, id) => {
    isScrollingRef.current = true
    setTimeout(() => {
      window.scrollTo({
        top: id === 'signUp' ? 0 : to.offsetTop - 150,
        behavior: 'smooth',
      })
    }, 100)

    setTimeout(() => {
      isScrollingRef.current = false
    }, 500)
  }

  return (
    <main>
      <section>
        <div className='container pt-24 pb-12'>
          <div className='grid grid-cols-1 md:grid-cols-12'>
            <div className='col-span-3 '>
              <FaqSection
                activeTab={activeTab}
                moveTo={moveTo}
                setActiveTab={setActiveTab}
              />
            </div>
            <div className='col-span-full md:col-span-9'>
              <DetailsSection
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default page
